<script lang="ts">
  import type {CssColor} from 'Catalyst/utility/theme';
  import {CardState} from 'Utility/users/signUpStore';

  import CatalystApp from 'Catalyst/components/CatalystApp/CatalystApp.svelte';
  import Logo from 'Components/SessionV2/Logo.svelte';
  import SignInForm from 'Components/SessionV2/SignInForm.svelte';
  import SignUpForm from 'Components/SessionV2/SignUpForm.svelte';

  export let whitelabelingSettingsPresent: boolean;
  export let logoUrl: string | null;
  export let companyName: string | null;
  export let googleAuthPath: string;
  export let appleAuthPath: string;
  export let facebookAuthPath: string;
  export let emailAuthPath: string;
  export let authenticityToken: string;
  export let forgotPasswordPath: string;
  export let termsAndConditionsUrl: string;
  export let companyPrimaryColor: string | null;
  export let alert: string | null;
  export let showSignUpOption: boolean = false;
  export let signUpPath: string = '';

  let cardState = CardState.SIGN_IN;

  const toggleCardState = (card: CardState): void => {
    cardState = card;
  };

  $: brandColors = companyPrimaryColor
    ? [
        {
          key: 'brand-color',
          value: companyPrimaryColor as CssColor,
        },
      ]
    : [];
</script>

<CatalystApp {brandColors} data-testid="session-v2-card">
  <div class="w-[26.6rem] max-[320px]:w-[100vw]">
    <div
      class="bg-white border !border-[#EAECF0] rounded-t-2xl h-[5.5rem] px-[2.5rem] flex justify-center items-center"
    >
      <Logo {whitelabelingSettingsPresent} {logoUrl} {companyName} />
    </div>
    <div
      class="flex flex-column gap-[1.5rem] bg-[#FCFCFD] border !border-[#EAECF0] rounded-b-2xl px-[2.5rem] pt-[2.5rem] pb-[3rem]"
    >
      {#if cardState === CardState.SIGN_IN}
        <SignInForm
          {emailAuthPath}
          {authenticityToken}
          {forgotPasswordPath}
          {companyPrimaryColor}
          {showSignUpOption}
          {googleAuthPath}
          {appleAuthPath}
          {facebookAuthPath}
          toggleSignUp={() => toggleCardState(CardState.SIGN_UP)}
          bind:alert
        />
      {:else}
        <SignUpForm
          {authenticityToken}
          {signUpPath}
          {companyPrimaryColor}
          toggleSignIn={() => toggleCardState(CardState.SIGN_IN)}
        />
      {/if}

      <span
        class="text-sm text-[#475467] font-normal"
        data-testid="terms-and-conditions-link"
      >
        By signing in, you accept DealMaker's <a
          href={termsAndConditionsUrl}
          target="_blank"
          class="hover:underline hover:cursor-pointer font-medium"
          style={`color: ${companyPrimaryColor || '#2E9990'}`}
          >terms & conditions</a
        > of use.
      </span>
    </div>
  </div>
</CatalystApp>
